import BlockType from 'src/enums/blockType';
import { Block } from 'src/types/shared/blocksV3';
import getBlock from 'src/utils/getBlockV3';

export function getUpdatedBlockEdges(blocks: Block[], newBlock: Block) {
	const oldBlock = getBlock(blocks, newBlock.id || '');

	if (!oldBlock) return newBlock.edges;

	const deckboxes = blocks.filter((blk) => blk.type == BlockType.DECKBOX);
	const landings = deckboxes.flatMap((dk) => dk.landings);
	const stairs = deckboxes.flatMap((dk) => dk.stairs);
	const bumpouts = deckboxes.flatMap((dk) => dk.bumpouts);

	const allBlocks = [...deckboxes, ...landings, ...stairs, ...bumpouts];

	return newBlock.edges.map((newEdge) => {
		const oldEdge = oldBlock.edges.find((edge) => edge.id == newEdge.id);

		if (!oldEdge) return newEdge;

		const lengthChange = newEdge.length - oldEdge.length;

		if (lengthChange) {
			const segmentsSum = newEdge.segments.reduce(
				(acc, seg) => acc + seg.length,
				0
			);

			if (segmentsSum === newEdge.length) {
				return newEdge;
			}

			const vacantSegmentIndex = newEdge.segments.findIndex((Segment) =>
				allBlocks.every((blk) => blk?.parentBlock.segmentId != Segment.id)
			);
			newEdge.segments = newEdge.segments.map((segment, index) => {
				return {
					...segment,
					length:
						index == vacantSegmentIndex
							? segment.length + lengthChange
							: segment.length,
				};
			});
		}

		return newEdge;
	});
}
